import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { FDataGrid } from '../grid';
import { ForecastMoneyCell, ForecastVarianceCell, ForecastPercentCell, ForecastConfidenceCell, ForecastStatusChip, ForecastDeltaClass, ForecastGridSx } from './ForecastGridRenderers';

type Props = { rows:any[]; loading?:boolean; selectedId?:any; onSelect?:(row:any)=>void };

class ForecastMetricGrid extends React.PureComponent<Props> {
  columns: GridColDef[] = [
    { field: 'metriccode', headerName: 'Metric', width: 160 },
    { field: 'metricname', headerName: 'Metric Name', width: 260, flex: 1, minWidth: 260 },
    { field: 'actualvalue', headerName: 'Actual', width: 140, renderCell: ForecastMoneyCell },
    { field: 'forecastvalue', headerName: 'Forecast', width: 140, renderCell: ForecastMoneyCell },
    { field: 'varianceamount', headerName: 'Variance', width: 140, renderCell: ForecastVarianceCell, cellClassName: ForecastDeltaClass },
    { field: 'variancepercent', headerName: 'Variance %', width: 130, renderCell: ForecastPercentCell, cellClassName: ForecastDeltaClass },
    { field: 'classification', headerName: 'Class', width: 140 },
  ];

  getRowId = (row:any) => row.rid || row.recid || row.id || `${row.batchcode}-${row.metriccode}-${row.periodcode || ""}`;

  render() {
    return (
      <FDataGrid
        title="Forecast Metrics"
        subtitle="Aggregated forecasting indicators and variance analysis."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={380}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#fff8e1' }}
        getRowId={this.getRowId}
        onRowClick={(p: any) => this.props.onSelect?.(p.row)}
        pageSizeOptions={[10, 25, 50]}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        sx={ForecastGridSx}
        // title="Forecast Metrics"
        // subtitle="Aggregated forecasting indicators and variance analysis."
        // rows={this.props.rows || []}
        // columns={this.columns}
        // loading={this.props.loading}
        // height=380
        // showQuickFilter
        // toolbarSx={{ backgroundColor: '#fff8e1' }}
        // getRowId={this.getRowId}
        // onRowClick={(p:any) => this.props.onSelect?.(p.row)}
        // pageSizeOptions=[10,25,50]
        // initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        // sx={ForecastGridSx}
      />
    );
  }
}

export default ForecastMetricGrid;
